var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#history_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M10.537 4.664H9.464a.18.18 0 0 0-.179.178v6.145c0 .059.027.112.074.146l3.69 2.694c.08.058.192.042.25-.038l.638-.87a.176.176 0 0 0-.038-.25l-3.183-2.302V4.842a.18.18 0 0 0-.179-.178m4.907 1.678 3.5.855a.18.18 0 0 0 .22-.172l.018-3.605a.178.178 0 0 0-.287-.14l-3.518 2.748a.179.179 0 0 0 .067.314m3.743 6.721-1.266-.435a.18.18 0 0 0-.225.107 7.845 7.845 0 0 1-1.828 2.848 7.88 7.88 0 0 1-5.585 2.315 7.878 7.878 0 0 1-5.585-2.315 7.9 7.9 0 0 1-1.694-2.51 7.9 7.9 0 0 1-.616-3.074c0-1.067.207-2.103.62-3.076a7.8 7.8 0 0 1 1.695-2.511 7.88 7.88 0 0 1 5.582-2.315 7.88 7.88 0 0 1 6.223 3.036l1.335-1.045A9.57 9.57 0 0 0 10.281.4a9.58 9.58 0 0 0-9.59 9.697c.054 5.257 4.329 9.5 9.594 9.5 4.14 0 7.668-2.625 9.011-6.302a.18.18 0 0 0-.109-.232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "history_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgHistory;